import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import styles from './NotFound.module.css';

const NotFound: React.FC = () => (
  <div className={styles.wrap}>
    <div className={styles.card}>
      <div className={styles.code}>404</div>
      <h1>Page not found</h1>
      <p>The page you're looking for doesn't exist or may have moved.</p>
      <Link to="/" className={styles.btn}><FiArrowLeft /> Back to home</Link>
    </div>
  </div>
);

export default NotFound;
